import IpagPaymentStatus from "../../../enums/IpagPaymentStatus"
import axios from 'axios'
import {AppConfig} from "../../../config/config"

export default class Ipag {

    static IPAG_WEBHOOK_URL = 'https://ef55prjn82.execute-api.us-east-1.amazonaws.com/production?schema='
    static ERROR_IPAG_RESPONSE = 'Ocorreu um erro ao processar o pagamento.'
    static ERROR_IPAG_REQUEST = 'Ocorreu um erro de comunicação com a operadora do cartão.'

    /**
     * Encapsula procedimento completo de venda com parceiro de venda IPag.
     *
     * @param doNeritSaleCallback
     * @param approveSaleFunc
     * @param cancelSaleFunc
     * @param ip
     * @param ipagId
     * @param ipagApiKey
     * @param ipagEndpoint
     * @param cardHolder
     * @param cardCompany
     * @param cardNumber
     * @param cardMonth
     * @param cardYear
     * @param cardCVV
     * @param saleBuyer
     * @param saleValue
     * @param installmentNumber
     *
     * @returns {Promise<any>}
     */
    static doPayment(
        doNeritSaleCallback,
        approveSaleFunc,
        cancelSaleFunc,
        ip,
        {
            ipagId,
            ipagApiKey,
            ipagEndpoint,
            cardHolder,
            cardCompany,
            cardNumber,
            cardMonth,
            cardYear,
            cardCVV,
            saleBuyer,
            saleValue,
            installmentNumber,
        }) {

        return new Promise(async (resolve, reject) => {

            // Executa venda no sistema nerit
            doNeritSaleCallback()
                .then(async saleResult => {

                    const {invoiceAccountCode} = saleResult
                    const {addressDTO, email, phoneOne, name, login,} = saleBuyer
                    const {street, number, neighborhood, city, state, cep} = addressDTO

                    // Executa venda no Ipag
                    Ipag.sendPaymentToIpag(
                        ipagId,
                        ipagApiKey,
                        ipagEndpoint,
                        invoiceAccountCode,
                        invoiceAccountCode,
                        saleValue,
                        email,
                        phoneOne,
                        cardHolder,
                        street,
                        number,
                        neighborhood,
                        city,
                        state,
                        'Brasil',
                        cep,
                        cardCompany,
                        cardNumber,
                        cardMonth,
                        cardYear,
                        cardCVV,
                        invoiceAccountCode,
                        Ipag.IPAG_WEBHOOK_URL + login.split('.')[0],
                        installmentNumber,
                        ip
                    )
                        .then(ipagResult => {

                            if (ipagResult.status_pagamento === IpagPaymentStatus.APROVADO_CAPTURADO)
                                approveSaleFunc(invoiceAccountCode)

                            resolve({success: true})

                        })
                        .catch(err => {
                            cancelSaleFunc(invoiceAccountCode)
                            reject(err)
                        })
                })
                .catch(reject)
        })
    }

    /**
     * Executa cadastro de 01 venda no Ipag.
     *
     * @param ipagId
     * @param ipagApiKey
     * @param endpoint
     * @param paymentId
     * @param orderNumber
     * @param value
     * @param clientEmail
     * @param clientPhone
     * @param cardHolder
     * @param clientAddressStreet
     * @param clientAddressNumber
     * @param clientAddressNeighborhood
     * @param clientAddressCity
     * @param clientAddressState
     * @param clientAddressCountry
     * @param clientAddressCEP
     * @param cardCompany
     * @param cardNumber
     * @param cardMonth
     * @param cardYear
     * @param cardCVV
     * @param document
     * @param webhook
     * @param installmentNumber
     * @param ip
     *
     * @returns {Promise<any>}
     */
    static sendPaymentToIpag(
        ipagId,
        ipagApiKey,
        endpoint,
        paymentId,
        orderNumber,
        value,
        clientEmail,
        clientPhone,
        cardHolder,
        clientAddressStreet,
        clientAddressNumber,
        clientAddressNeighborhood,
        clientAddressCity,
        clientAddressState,
        clientAddressCountry,
        clientAddressCEP,
        cardCompany,
        cardNumber,
        cardMonth,
        cardYear,
        cardCVV,
        document,
        webhook,
        installmentNumber,
        ip
    ) {

        return new Promise(async (resolve, reject) => {

            const endpoint = AppConfig.ipagEndpoint

            const paymentData = {
                endpoint,
                ipagId,
                ipagApiKey,
                identificacao: 'id_'+paymentId,
                pedido: orderNumber,
                valor: value,
                metodo: cardCompany,
                operacao: 'Pagamento',
                url_retorno: webhook,
                retorno_tipo: 'json',
                email: clientEmail,
                fone: clientPhone,
                nome: cardHolder,
                endereco: clientAddressStreet,
                bairro: clientAddressNeighborhood,
                cidade: clientAddressCity,
                estado: clientAddressState,
                pais: clientAddressCountry,
                cep: clientAddressCEP,
                num_cartao: cardNumber.replace(' ', ''),
                mes_cartao: cardMonth,
                ano_cartao: cardYear,
                cvv_cartao: cardCVV,
                documento: 'doc_'+document,
                parcelas: installmentNumber,
                ip
            }

            if(!!clientAddressNumber) {
                paymentData.numero_endereco = clientAddressNumber
            }

            axios({
                method: 'post',
                url: AppConfig.ipagCloudFunctionEndpoint,
                data: paymentData
            })
                .then(res => res.data)
                .then(result => {

                    const successStatus = [
                        IpagPaymentStatus.APROVADO_CAPTURADO,
                        IpagPaymentStatus.APROVADO,
                    ]

                    if (successStatus.indexOf(result.status_pagamento) >= 0)
                        resolve(result)
                    else
                        reject(Ipag.ERROR_IPAG_RESPONSE)
                })
                .catch(err => {
                    console.error('FAILURE - Send IPag payment to cloud function: ', err)
                    reject(Ipag.ERROR_IPAG_REQUEST)
                })
        })
    }
}



// WEBPACK FOOTER //
// ./src/_pages/Sale/_functions/ipag.js